import React from 'react';
import { CheckCircle } from 'lucide-react';
export function HeroSection() {
  return <section className="bg-white py-8 md:py-12 px-4 overflow-hidden" data-id="element-67">
      <div className="max-w-3xl mx-auto text-center" data-id="element-68">
        <p className="text-gray-600 font-semibold mb-2 uppercase tracking-wider text-sm" data-id="element-69">
          📚 Para padres y docentes de primaria
        </p>

        <h1 className="text-3xl md:text-5xl font-black text-gray-900 mb-2 leading-tight font-['Oswald'] uppercase" data-id="element-70">
          Aprende el Cuerpo Humano{' '}
          <span className="text-[#2980b9]" data-id="element-71">Jugando</span>
        </h1>

        <h2 className="text-lg md:text-xl text-gray-700 font-bold mb-4 bg-yellow-100 inline-block px-3 py-1 rounded-sm transform -rotate-1" data-id="element-72">
          Guía Educativa – 6 Tomos + 3 Bonos
        </h2>

        <a href="#compra" className="mb-6 relative group cursor-pointer block" data-id="element-73">
          <div className="absolute -inset-1 bg-gradient-to-r from-blue-600 to-cyan-500 rounded-lg blur opacity-25 group-hover:opacity-50 transition duration-1000 group-hover:duration-200" data-id="element-74"></div>
          <img src="https://cdn.magicpatterns.com/uploads/saYUTDYpN8fr6GUJP11rvk/mockup_guia_educativa_para_ninos.png" alt="Guía Educativa para Niños - Cuerpo Humano" className="relative mx-auto w-full max-w-sm transform transition hover:scale-105 duration-300" data-id="element-75" />
        </a>

        <div className="max-w-2xl mx-auto space-y-2 mb-6" data-id="element-76">
          <p className="text-lg md:text-xl text-gray-800 font-medium" data-id="element-77">
            Todo el material de Ciencias Naturales que necesitás, listo para
            usar.
          </p>
          <p className="text-base text-gray-600" data-id="element-78">
            Clases claras, organizadas y sin pasar horas planificando. Dejá de
            empezar desde cero cada semana.
          </p>
        </div>

        <div className="flex flex-col items-center gap-3" data-id="element-79">
          <a href="#compra" className="bg-[#22c55e] hover:bg-[#16a34a] text-white text-lg md:text-xl font-black py-4 px-6 md:px-10 rounded-lg shadow-[0_4px_0_#15803d] active:shadow-[0_2px_0_#15803d] active:translate-y-1 transition-all w-full max-w-md uppercase flex items-center justify-center gap-2 animate-pulse no-underline" data-id="element-80">
            👉 Sí, quiero acceder ahora
          </a>

          <div className="flex items-center gap-2 text-gray-600 font-semibold text-sm" data-id="element-81">
            <CheckCircle className="w-4 h-4 text-green-500" data-id="element-82" />
            <span data-id="element-83">Garantía de satisfacción de 7 días</span>
          </div>
        </div>
      </div>
    </section>;
}